export enum CalendarBoxType {
  regular = 'regular',
  confirmed = 'confirmed',
  confirmedAfter = 'confirmedAfter',
  resume = 'resume',
  skipped = 'skipped',
  today = 'today'
}
